import React from "react";

const UsersIcon = () => (
  <svg
    width="1.33rem"
    height="1.33rem"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.09331 6.34083C7.03497 6.335 6.96497 6.335 6.90081 6.34083C5.51247 6.29416 4.40997 5.15666 4.40997 3.75666C4.40997 2.3275 5.56497 1.16666 6.99997 1.16666C8.42914 1.16666 9.58997 2.3275 9.58997 3.75666C9.58414 5.15666 8.48164 6.29416 7.09331 6.34083Z"
      stroke="#7E858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.17667 8.49333C2.765 9.43833 2.765 10.9783 4.17667 11.9175C5.78084 12.9908 8.41167 12.9908 10.0158 11.9175C11.4275 10.9725 11.4275 9.43249 10.0158 8.49333C8.4175 7.42583 5.78667 7.42583 4.17667 8.49333Z"
      stroke="#7E858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UsersIcon;
